import React, {useState} from 'react';
import { useSelector, useDispatch } from "react-redux";

import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Tooltip from '@material-ui/core/Tooltip';
import { lightBlue } from '@material-ui/core/colors'; 
import Grid from '@material-ui/core/Grid';
import SingleSelectNative from '../singleSelectNative/singleSelectNative';
import SingleSelectPlain from '../singleSelectPlain/singleSelectPlain';
import MultiSelectWithAllOptionPlain from '../multiSelectWithAllOptionPlain/multiSelectWithAllOptionPlain';
import MultiSelectWithAllOption from '../multiSelectWithAllOption/multiSelectWithAllOption';

import { getMprDetailsForMonitoringsFilter2, getMprDetailsForMonitorings, getMprDetailsForMonitoringsSimple, getMprDetailsForMonitoringsBoth } from '../../redux/actions/mprDetails';
import { getTimePeriodByReport, retrieveActualReports, getFilteredMpReports } from '../../redux/actions/mpReports';
import { getJointCitiesFromMpDetailsByDate, getMpDetailsForMonitorings, getFilteredMpDetailsSimple, getFilteredClientsGoFromMpDetails } from '../../redux/actions/mpDetails';
import { setTheFilter, setTheMode, showAuto } from '../../redux/actions/shared';
import { getCitiesByReport, retrieveCities } from '../../redux/actions/cities';

import mpReports from '../../services/mpReports';

import {_baseApiUrl} from '../../redux/constants';
import {getMonthsList, cityNameToId} from '../../utils/shared';  


const useStyles = makeStyles((theme) => ({  
    root: {
      display: 'flex',
      flexDirection: 'row', 
      fleWrap: 'nowrap',
    },      
    success: {
        flexBasis: '75%',
        padding: '14px;',
        marginRight: '0px;',
        color: '#fff',
        // marginBottom: '10px;',
    },
    export: {
      color: 'black',
    },
    cancel: {
        flexBasis: '25%',
        padding: '14px;',
        color: '#fff',
        // backgroundColor: theme.palette.secondary.main,
    },
    additional: {
        flexBasis: '75%',
        padding: '14px;',
        backgroundColor: lightBlue[700],
        color: '#fff',
    },
    container: {
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
    },
    formControl: {
        margin: theme.spacing(2),
        minWidth: 120,
    },
    formcontrol: {
      paddingLeft: '14px;'
    },
    paper: {
      display: 'flex',
      justifyContent: 'center',
      flexWrap: 'wrap',
      listStyle: 'none',
      padding: theme.spacing(0.5),
      marginBottom: '20px;',
    },
    checkbox: {
      visibility: 'visible',
      backgroundColor: 'white',
      '&:hover': {
        backgroundColor: 'white',
      },
    },
    title: {
      padding: '10px;',
      paddingLeft: '24px;',
    },
    dialogcontent: {
      padding: '8px 24px 24px 24px',
    },
    dialogcontainer: {
      marginBottom: '10px',
    },

  }));

  function makeClientGoType(item){
    return {
      id: item.ctg_id,
      united: item.ctg_name,
    }
  }

const monthsList = getMonthsList(12);

export default function MonitoringsDialog2() {
  const classes = useStyles();

  const { actualReports, timePeriodId,  filteredMpReports } = useSelector(state => state.mpReports);
  const {cities} = useSelector(state => state.cities);
  const { allCities, jointCities, filteredClientsGoFromMpDetails } = useSelector(state => state.mpDetails);
  
  
  const {user_role, user_permissions} = useSelector(state => state.users);

  const dispatch = useDispatch();
  
  const [open, setOpen] = useState(false);

  const [currency, setCurrency] = useState('');

  
  //const [month, setMonth] = useState('');
  const [simple_mpr_id, setSimpleMprId] = useState(''); // mp_reports ОБЫЧНЫЙ
  const [mpd_city, setMpdCity] = useState('');          // mp_details  
  const [mpr_id, setMprId] = useState('');             // mp_reports МАССОВЫЙ
  
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const getFilter = function(dtoObj, property, action){
    return function(newValue){
      dtoObj[property] = newValue;
      console.log('obj', dtoObj);
      dispatch(action(dtoObj));
    }
  };

  const getOther = function(dtoObj, action){
    return function(){
      console.log('obj', dtoObj);
      dispatch(action(dtoObj));
    }
  };

  const loadData = () => {

    const data = {
      simple_mpr_id: simple_mpr_id,
      mpr_id: mpr_id,
      mpd_city_id: mpd_city,
    };

    dispatch(getMprDetailsForMonitoringsFilter2(data));

    handleClose();
  }

      // console.log('data: ', data);
  // console.log('month: ', month);
  // console.log('mpd_city: ', mpd_city);
  // console.log('simple_mpr_id: ', simple_mpr_id);
  // console.log('cities: ', cities);
  // console.log('timePeriodId: ', timePeriodId);
  // console.log('mpr_id: ', mpr_id);
  // console.log('filteredClientsGoFromMpDetails: ', filteredClientsGoFromMpDetails);
  


  return (
    <div>
      <Grid container spacing={2} alignItems={'center'} className={classes.dialogcontainer}>

        <Grid item>
        <Tooltip title="Месяц -> Город -> Отчет обычного мониторинга -> Отчет масс мониторинга">
          <Button
              variant="contained"
              size="large"
              color="secondary" 
              className={classes.success}
              onClick={handleClickOpen}
          > 
              РУЧНОЙ
          </Button>
          </Tooltip>
        </Grid>


        <Grid item>
        <Dialog disableBackdropClick disableEscapeKeyDown open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title" className={classes.title}>Фильтр</DialogTitle>
          
          <DialogContent className={classes.dialogcontent}>

              <form className={classes.container}>
                <Grid container spacing={1} display="flex" direction="column"  wrap="nowrap" alignItems="baseline">

                  <Grid item>
                    <SingleSelectNative
                      label={"Обычный мониторинг"}
                      style={{width: 350}}
                      value={simple_mpr_id}
                      setValue={setSimpleMprId}
                      options={actualReports}
                      fn={getFilter(
                        {
                          mpr_id: '',
                        },
                        'mpr_id',
                        getCitiesByReport
                      )}                  
                    />
                  </Grid>

                  {cities.length>0 && simple_mpr_id &&
                  <Grid item>
                    <SingleSelectNative
                      label={"Город"}
                      style={{width: 350}}
                      value={ mpd_city}
                      setValue={setMpdCity}
                      options={cities}
                      fn={getOther(
                        {
                          mpr_id: simple_mpr_id,
                        },
                        getTimePeriodByReport
                      )}                  
                    />
                  </Grid>}

                  {filteredMpReports.length>0 && cities.length>0 && simple_mpr_id &&
                  <Grid item>
                    <MultiSelectWithAllOptionPlain
                      label={"Масс Мониторинг"}
                      style={{width: 350}}
                      value={mpr_id}
                      selected={mpr_id}
                      onChange={setMprId}
                      items={filteredMpReports}
                      //items={user_role === 'Admin' ? filteredMpReports : filteredMpReports.filter(item => user_permissions.reports.includes(item))}
                      
                    />
                  </Grid>}
             
                </Grid>
              </form>
          </DialogContent>
          
          <DialogActions>
            <Button 
              onClick={handleClose} 
              color="primary"
            >
              Отмена
            </Button>

            {mpr_id.length>0 &&
            <Button 
              color="secondary"
              onClick={loadData}
            >
              Загрузить данные
              </Button>}
            
          </DialogActions>
        </Dialog>
      </Grid>

    </Grid>
      
    </div>
  );
}